import axios from 'axios'

const state = {
  priceHiddenMode: false
}

const actions = {
  
}


const getters = {
  priceHiddenMode: state => state.priceHiddenMode,
}

const mutations = {
  setPriceHiddenMode(state, priceHiddenMode) {
    state.priceHiddenMode = priceHiddenMode
    localStorage.setItem('priceHidden', state.priceHiddenMode)
},
}

export default {
  state,
  getters,
  actions,
  mutations
}
